import { stringifyUrl } from '@shared/utils/route';

import { get, post } from '..';

export interface BankHolidayOrSpecialDay {
  id: number;
  description: string;
  date: string;
}

export interface BankHolidaysAndSpecialDays {
  bankHolidays: BankHolidayOrSpecialDay[];
  specialDays: BankHolidayOrSpecialDay[];
}

export const fetchBankHolidaysAndSpecialDays = (
  groupId: number,
  fromDate: string,
  toDate: string,
) =>
  get<BankHolidaysAndSpecialDays>(
    stringifyUrl(`/v1/bank-holidays/with-special-days/by-group/${groupId}`, {
      fromDate,
      toDate,
    }),
  );

interface IBreak {
  begin: string;
  end: string;
  id: number;
  shiftId: number;
}

export const fetchCalculatedBreaks = (shift: unknown) =>
  post<IBreak>('/v1/schedule/breaks/calculate', shift);

export const fetchBSCalculatedBreaks = (shift: unknown) =>
  post('/v1/schedule/breaks/baseschedule/calculate', shift);
